import type { FaireProductEntity } from "../../entity_types/product";

export const p_h8rqzq74u3: FaireProductEntity = {
  token: "p_h8rqzq74u3",
  type: "product",
  name: "No. 143 Clara Bandana",
  brandToken: "b_9noaizffyc",
  brandName: "Handker Bandanas",
  imageUrl:
    "https://cdn.faire.com/fastly/7af79187d026ee1b4ace49ac3ff054a80dcf34db650a98b4aae80b18c4bb7f0c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9c77132f2fec82c9a0bc57fd50df8362405c726a0330c12d711ceb7397a9f387.png",
    "https://cdn.faire.com/fastly/7e35ee71cf289376c1a861addb7aedeed5c6ded3446f2108c155669ddebd2a46.png",
    "https://cdn.faire.com/fastly/73c93a61021da6e61518dcbc7e969f8a08034d52b488d7d2b2b8a23192dfeb7a.png",
    "https://cdn.faire.com/fastly/5812c80135d35cf27237609be0e52f5040a766df812659f6b7dfb095b3777335.png",
    "https://cdn.faire.com/fastly/b824cd333d431d172ba8aff1f2ae992f348b48c9dafb20ed14d9b9ec689c926a.png",
    "https://cdn.faire.com/fastly/1760580076bcf8df222a127e16f1da8b984e9e13050dde652b556cc09f5c53a6.png",
    "https://cdn.faire.com/fastly/a280f9f5bd72e5500d82d8f44b1bfc3e403b94f35e618c776ce68d3a8a105e80.png",
  ],
  priceDollars: 9.5,
  description:
    "Clara slips into the lake like a secret. She’s always the first one to dive in and you’ll see the top of her face more than the rest of her. She peers over the water’s surface, hair slicked back and eyes bright with mischief. She hums Girl Scout songs you forgot you knew and will teach you how to skip rocks. When you call out that dinner is ready, she only begrudgingly leaves the water, and she’ll happily show you her favorite constellations after dessert.\n\nColor: Grass and olive green, periwinkle, purple\n\nMaterial: 100% premium cotton\n\nSizing: 22x22 inches\n\nDesigned in the U.S.\n\nPrinted in India\n\nA bandana can be used in so many different ways! Use it as a handkerchief on hikes, wear it in your hair or on your clothes to spice up an outfit, or tie it around your pup's neck to make them look dashing. Have fun with it!",
  tags: [],
  msrpDollars: 19,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:44.715Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
